import {
    usePortfolioSelection,
    usePortfolioManagement,
    usePortfolioProfile,
} from "../../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import dayjs, { Dayjs } from 'dayjs';
import { ProfileType } from "../../../options-table/types/ProfileType";
import { dateTimeConversionService } from "../../../../shared/services/DateTimeConversionService";
import { ApplicationDateTimePicker } from "../../../../shared/components/date-time-picker/ApplicationDateTimePicker";
import { CustomDateTimePickerTooltipContent } from "./CustomDateTimePickerTooltipContent";

export function CustomDateTimePicker() {
    const {
        selectedPortfolio,
        selectedPortfolioDates,
    } = usePortfolioSelection();
    const {
        saveSelectedPortfolio,
    } = usePortfolioManagement();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();

    async function handleSelection(selectedDate: Dayjs | null) {
        if (selectedDate == null ||
            selectedPortfolio === undefined ||
            selectedPortfolio === null ||
            selectedPortfolio.portfolioSettings === null
        ) {
            return;
        }
        
        selectedPortfolio.portfolioSettings.selectedCustomDate = dateTimeConversionService.toUtcDate(selectedDate);
        updateSelectedPortfolio();
        saveSelectedPortfolio();
    }

    const selectedProfileTypes = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.selectedProfileTypes
        : [];
    
    const isTripleCustomBalanceEnabled = selectedPortfolio!.portfolioSettings!.isTripleCustomBalanceEnabled;
    
    return (
        <ApplicationDateTimePicker
            value={selectedPortfolio !== undefined && selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
                ? dayjs(selectedPortfolio.portfolioSettings.selectedCustomDate)
                : dayjs()}
            onChange={handleSelection}
            width={175}
            slotProps={{
                textField: {
                    InputProps: {
                        sx: {
                            '&:before, &:after': {
                                borderBottom: 'none',
                            },
                            '&.MuiInput-underline.Mui-disabled:before': {
                                borderBottom: 'none',
                            },
                            '&:hover:not(.Mui-disabled, .Mui-error):before': {
                                borderBottom: 'none',
                            },
                            fontSize: '14px',
                            fontWeight: 'bold',
                            height: '24px',
                            margin: '0px 0px 0px 0px',
                            padding: '5px 0px 0px 4px',
                            border: '1px solid #36454B',
                            borderRadius: '4px',
                            boxSizing: 'border-box',
                        }
                    }
                },
            }}
            sx={{
                margin: '0px 0px 0px 0px',
                color: '#36454B',
                '&:before, &:after': {
                    borderBottom: 'none',
                },
                '&.MuiInput-underline.Mui-disabled:before': {
                    borderBottom: 'none',
                },
                '&:hover:not(.Mui-disabled, .Mui-error):before': {
                    borderBottom: 'none',
                },
                '.MuiFormLabel-root': {
                    fontWeight: 'bold'
                },
                '& .MuiInputAdornment-root': {
                    marginLeft: '0px',
                    marginRight: '0px',
                },
                '& .MuiSvgIcon-root': {
                    fontSize: '21px',
                    marginTop: '-3px',
                    marginRight: '5px',
                },
            }}
            tooltipTitle={
                <CustomDateTimePickerTooltipContent
                    selectedPortfolioDates={selectedPortfolioDates!}
                    isTripleCustomBalanceEnabled={isTripleCustomBalanceEnabled}
                />
            }
            tooltipPlacement='left-start'
            tooltipMaxWidth='500px'
            disabled={selectedProfileTypes.indexOf(ProfileType.Custom) === -1}
        />
    );
}
